module.exports = __webpack_public_path__ + "assets/media/droid-view.d1c116d9.png";